// Author lidongxu
// Date 2024-02-22 10:33:31

import * as model from "@/model/sithMes/stool/SithMesStoolPrApplicationIndirectPurchaseDetailModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesStoolPrApplicationIndirectPurchaseDetail(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_STOOL_URL,
    })
    .buildStore()
